import Headline from '../../../../components/Headline';
import Description from '../../../../components/Description';
import Button from '../../../../components/Button';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../../store/selectors/products';
import { useCallback } from 'react';

const Docs = () => {
  const { data } = useSelector(selectProduct);
  const { docs } = data;

  const handleButtonRedirect = useCallback(() => {
    window.open(docs?.url, '_blank');
  }, [docs]);

  return (
    <div className='integration'>
      <Headline message='Integration docs headline' />

      <Description message='Integration docs description' />

      <Button type='secondary' icon='link' label='Integration go to' onCallback={handleButtonRedirect} />
    </div>
  );
};

export default Docs;
